/**
 * contains the abi and contract address
*/

class NoteSequencesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleIpfs",
				"type": "bytes32"
			},
			{
				"name": "notes",
				"type": "bytes32[32]"
			},
			{
				"name": "startTime",
				"type": "uint32"
			},
			{
				"name": "endTime",
				"type": "uint32"
			},
			{
				"name": "noteSequenceIpfs",
				"type": "bytes32"
			}
		],
		"name": "newNoteSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleIpfs",
				"type": "bytes32"
			},
			{
				"name": "notes",
				"type": "bytes32[256]"
			},
			{
				"name": "startTimes",
				"type": "uint32[8]"
			},
			{
				"name": "endTimes",
				"type": "uint32[8]"
			},
			{
				"name": "noteSequenceIpfs",
				"type": "bytes32"
			}
		],
		"name": "newNoteSequenceLarge",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "noteSequenceIpfs",
				"type": "bytes32"
			}
		],
		"name": "NewNoteSequence",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "noteA",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "noteB",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "startTime",
				"type": "uint32"
			},
			{
				"indexed": false,
				"name": "endTime",
				"type": "uint32"
			},
			{
				"indexed": false,
				"name": "remainingNotes",
				"type": "bytes32"
			}
		],
		"name": "NewNotesAggregation",
		"type": "event"
	}
        ];

        this.contractAddress = '0x3edab21966363a5c9d69ba0ed78abc5b9c6007c5';
    }
}

export default NoteSequencesContract;
	
